import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Collapse,
  Textarea,
  Card,
  CardBody,
  Divider,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";

import {
  BrowserRouter as Router,
  generatePath,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";

import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import DatePicker from "../../components/date-picker";
import { formatDate_YYYY_MM_DD, getLoginID, useScreenType } from "../../auth";
import {
  AddReferHospitals,
  DeleteReferHospitals,
  GetReferHospitals,
  UpdateReferHospitals,
} from "../../middleware/services/referhospitals";
import { format } from "date-fns";

const ReferHospitals = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [hospitalData, setHospitalData] = useState([]);
  const [editHospitalData, setEditHospitalData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [hospitalId, setHospitalId] = useState(null);
  const [hospitalName, setHospitalName] = useState(null);
  const [hospitalEmail, setHospitalEmail] = useState(null);
  const [hospitalMobile, setHospitalMobile] = useState(null);
  const [hospitalBranch, setHospitalBranch] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  var itemPerPageCommonValue = 10;
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);

  const addHospital = useRef();
  const editHospital = useRef();
  const deleteHospitalDataModal = useRef();
  const screenType = useScreenType()
  const navigate = useNavigate()

  function openHospitalModal(id, operation) {
    if (operation === "add") {
      setHospitalName("");
      setHospitalEmail("");
      setHospitalMobile("");
      setHospitalBranch("");
      addHospital.current.openRight();
    } else {
      setHospitalId(id);
      const editableData = hospitalData.find((item) => item.id === id);
      if (editableData) {
        setEditHospitalData(editableData);
        setHospitalName(editableData.hospitalname);
        setHospitalEmail(editableData.email);
        setHospitalMobile(editableData.mobile);
        setHospitalBranch(editableData.address);
        editHospital.current.openRight();
      }
    }
  }

  const openDeleteModal = (id, value) => {
    setHospitalId(id);
    setHospitalName(value);
    deleteHospitalDataModal.current.openModal();
  };

  const saveHospitalData = async () => {
    const inputToSave = {
      input: {
        doctorid: getLoginID(),
        hospitalname: hospitalName,
        email: hospitalEmail,
        mobile: hospitalMobile,
        address: hospitalBranch,
      },
    };
    if (!hospitalName) {
      showErrorToast("Please enter Center name");
      return false;
    } else {
      showLoader();
      const res = await AddReferHospitals(inputToSave.input);
      // setHospitalData((prevData) => [...(prevData || []), inputToSave]); // Ensure prevData is iterable
      setRefresh(!refresh);
      showSuccessToast("Center added successfully.");
      fetchHospitalData();
      dismissLoader();
    }
    addHospital.current.closeRight();
  };
  const updateHospitalData = async () => {
    const inputToSave = {
      input: {
        id: hospitalId,
        doctorid: getLoginID(),
        hospitalname: hospitalName,
        email: hospitalEmail,
        mobile: hospitalMobile,
        address: hospitalBranch,
      },
    };

    if (!hospitalName) {
      showErrorToast("Please enter Center name");
      return false;
    } else {
      const res = await UpdateReferHospitals(inputToSave.input);
      setEditHospitalData("");
      setHospitalName("");
      setHospitalEmail("");
      setHospitalMobile("");
      setHospitalBranch("");
      showSuccessToast("Center updated successfully.");
      fetchHospitalData();
      editHospital.current.closeRight();
      return res;
    }
  };

  const fetchHospitalData = async () => {
    // const inputToFetch = {
    //   input: {
    //     doctorid: getLoginID(),
    //     searchtext: "",
    //     fromdate: "",
    //     todate: "",
    //     pageno: pageno,
    //     pagesize: pagesize,
    //   },
    // };
    const input = {
        doctorid: getLoginID(),
        searchtext: "",
        fromdate: "",
        todate: "",
        pageno: pageno,
        pagesize: pagesize,
    };
    showLoader();
    try {
      const result = await GetReferHospitals(input);
      setHospitalData(result.output.data);
      let count = result?.output.count;
      let pageno = result?.output.pageno;
      let pagesize = result?.output.pagesize;
      setTotalItemCount(count);
      let totalPagesCalc = count / pagesize;
      let totalPagesCount = Math.ceil(totalPagesCalc);

      setTotalPages(totalPagesCount);
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
    return;
  };

  const deleteHospitalData = async () => {
    const inputToDelete = {
      input: {
        doctorid: getLoginID(),
        id: hospitalId,
      },
    };
    showLoader();
    try {
      const result = await DeleteReferHospitals(inputToDelete.input);
      showSuccessToast("Hospital deleted successfully.");
    } catch (error) {
      console.log("Error in deleting the Refer center data", error);
    }
    fetchHospitalData();
    dismissLoader();
    return;
  };

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };

  async function handleFilter() {
    const trimmedName = searchValue?.trim();
    const inputToFetch = {
      input: {
        doctorid: getLoginID(),
        searchtext: trimmedName,
        fromdate: "",
        todate: "",
        pageno: pageno,
        pagesize: pagesize,
      },
    };
    showLoader();
    try {
      const result = await GetReferHospitals(inputToFetch.input);
      if (result && result.output.data) {
        setHospitalData(result.output.data);
      } else {
        setHospitalData([]);
      }
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  async function resetFeilds() {
    setHospitalName("");
    setHospitalEmail("");
    setHospitalMobile("");
    setSearchValue("");
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1);
    setCountTo(itemPerPageCommonValue);
    setCurrentPage(1);
    fetchHospitalData();
  }

  const handleNextClick = () => {
    let page = pageno + 1;

    setPageno(page);
    setCurrentPage(currentPage + 1);

    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;

    setPageno(page);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchHospitalData();
  }, [currentPage]);

  const TableHeader = [
    { key: "center", label: "Hospital Name" },
    { key: "email", label: "Email" },
    { key: "mobile", label: "Mobile no." },
    { key: "actions", label: "Actions" },
  ];

  const gobackfunction = ()=>{
    window.history.back();
   }

  return (
    <>
    {screenType === "web" ? (
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box w="100%">
            <SecondaryNav withBack="Referring Centers" goBack={gobackfunction} />
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box
                gap="10px"
                // pl="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="start"
                alignItems="center"
              >
                <PrimaryInput
                  variant="fullRound"
                  title="Search by name, email, mobile"
                  inputPlace="Search by name, email, mobile"
                  id={"searchName"}
                  inputStyleCss={{ w: "350px" }}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => handleChangeName(e)}
                  inputValue={searchValue}
                />
                <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  onClick={() => handleFilter()}
                  btnStyle={{ m: "0", w: "125px" }}
                />
                <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                  onClick={() => resetFeilds()}
                />
              </Box>
              <PrimaryButton
                buttonText="Add"
                onClick={() => openHospitalModal("", "add")}
                btnStyle={{ m: "0" }}
                w="125px"
                //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
              />

              {/* {noData && <p>No data available</p>} */}
            </Box>
            {hospitalData && hospitalData.length > 0 ? (
              <>
                <Box width="100%">
                  <Box
                    h="calc(100vh - 90px)"
                    overflow="hidden auto"
                    border="1px solid #E6E7E9"
                  >
                    <SimpleTable
                      headers={TableHeader}
                      className="tableContainer"
                      isDataPresent={true}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                      tableHeader={{ pos: "sticky", top: "0", bg: "white" }}
                      footerStyle={{
                        pos: "fixed",
                        bottom: "0",
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                        zIndex: "99",
                        width: "100%",
                      }}
                      tableStyle={{
                        maxH: "calc(100vh - 200px)",
                        overflowY: "auto",
                        tableLayout: "fixed",
                        width: "100%",
                        h: "100%",
                      }}
                      tableBody={
                        <>
                          {hospitalData &&
                            hospitalData.map((item, index) => (
                              <Tr w="100%" key={index}>
                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {item.hospitalname}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    title={""}
                                    whiteSpace="pre-line"
                                    overflow="hidden"
                                    fontSize={"s"}
                                    textAlign={"left"}
                                  >
                                    {item.email}
                                  </Box>
                                </Td>

                                <Td maxW="150px">
                                  <Box width="15%" textAlign={"left"}>
                                    {item.mobile}
                                  </Box>
                                </Td>

                                <Td maxW="130px" pos="relative">
                                  <Menu>
                                    <MenuButton as="button" zIndex={1}>
                                      <Image
                                        w="1.5rem"
                                        src="/assets/svgs/more-options.svg"
                                      />
                                    </MenuButton>
                                    <MenuList
                                      zIndex={9}
                                      pos="relative"
                                      right="-33px"
                                      minW="125px"
                                    >
                                      <MenuItem
                                        onClick={() =>
                                          openHospitalModal(item.id, "edit")
                                        }
                                        // isDisabled={ actionAccess && (!actionAccess.update) ? true : false}
                                      >
                                        Edit
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() => {
                                          openDeleteModal(
                                            item.id,
                                            item.hospitalname
                                          );
                                        }}
                                      >
                                        Delete
                                      </MenuItem>
                                    </MenuList>
                                  </Menu>
                                </Td>
                              </Tr>
                            ))}
                        </>
                      }
                      footerSection={
                        <>
                          <Tr w="100%">
                            <Td colSpan={5} w="calc(100vw - 6.5rem)">
                              <Box
                                w="100%"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box
                                  visibility={
                                    totalItemCount < countTo &&
                                    !totalExceedsPageCount
                                      ? "hidden"
                                      : "visible"
                                  }
                                >
                                  <Text>
                                    Showing <b>{countFrom}</b> to{" "}
                                    <b>{countTo}</b> of {totalItemCount} results
                                  </Text>
                                </Box>

                                <Box
                                  gap="2.5rem"
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    as="button"
                                    onClick={handlePrevClick}
                                    disabled={currentPage === 1}
                                    visibility={
                                      currentPage === 1 ? "hidden" : "visible"
                                    }
                                    p="0.5rem 0.75rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    fontSize="1rem"
                                    fontWeight="500"
                                  >
                                    Previous
                                  </Box>
                                  <Box>
                                    <Text
                                      textAlign="center"
                                      fontSize=".875rem"
                                      fontWeight="600"
                                    >
                                      Page {currentPage} of {totalPages}
                                    </Text>
                                  </Box>
                                  {totalItemCount >= countTo &&
                                    !totalExceedsPageCount && (
                                      <Box
                                        as="button"
                                        p="0.5rem 0.75rem"
                                        mr="2.5rem"
                                        border="0.0625rem solid #E6E7E9"
                                        borderRadius="0.75rem"
                                        onClick={handleNextClick}
                                        disabled={currentPage === totalPages}
                                        visibility={
                                          currentPage === totalPages
                                            ? "hidden"
                                            : "visible"
                                        }
                                        fontSize="1rem"
                                        fontWeight="500"
                                      >
                                        Next
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </Td>
                          </Tr>
                        </>
                      }
                    />
                  </Box>
                </Box>
              </>
            ) : (
              <Box width="100%">
                <SimpleTable
                  headers={TableHeader}
                />
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    ) : (
      <>
      <MobileNavbar />
         <MobileSecondaryNav
           header="Referring Centers"
           handlebackarrow={() => navigate(`/profile`)}
         />
       <Box
         w="100%"
         display="flex"
         justifyContent="space-between"
         alignItems="center"
         p="1rem"
         gap='0.75rem'
       >
         <SearchBar
          passInputPlace="Search by name, email, mobile"
          onKeyDown={handleKeyDown}
          onChange={(e) => handleChangeName(e)}
          handleClick={() => handleFilter()}
          searchValue={searchValue}
          placeholderMaxWidth='150px'
         />
        <PrimaryButton
          buttonText="Reset"
          id="resetButton"
          variant="grayBtn"
          btnStyle={{ color: "#AA2F27", m: "0", w: "75px" }}
          onClick={() => resetFeilds()}
        />
         <PrimaryButton
           buttonText="Add"
           onClick={() => openHospitalModal("", "add")}
           variant="mdBtn"
           btnStyle={{w:'75px'}}
          //  isDisabled={actionAccess && !actionAccess.create ? true : false}
         />
       </Box>
       <Divider />
       <Flex w='100%' gap='1rem' p='1rem' flexDir='column' maxH="calc(100vh - 275px)" overflow='hidden auto'>
       {hospitalData && hospitalData.length > 0 ? (
         hospitalData.map((item, index) => (
         <Card
           borderRadius="12px"
           key={index}
           w="100%"
           border="1px solid #E6E7E9"
           boxShadow="0px 8px 20px 0px #E6E7E966"
         >
           <CardBody p={{base: "0.875rem",lg: "0.875rem", xl: "1.25rem"}}>
             <Box
               display="flex"
               alignItems="center"
               justifyContent="space-between"
               mb="0.75rem"
             >                  
               <Box cursor="pointer" display="flex" alignItems="center">
                 <Box display="flex" flexDirection="column" justifyContent="center">
                   <Text fontSize="15px" fontWeight="600" className="textOverflow" title={item.productname ? item.productname : "-"} maxW={{base: "180px", xl:"110px"}}>
                   {item.hospitalname ? item.hospitalname : "-"}
                   </Text>
                 </Box>
               </Box>

                 <Box display="flex" gap="10px">
                   <Menu isLazy>
                     <MenuButton as="button" zIndex={1}>
                       <Image
                         w="1rem"
                         src="/assets/svgs/more-options.svg"
                         transform='rotate(90deg)'
                       />
                     </MenuButton>
                     <MenuList
                       zIndex={9}
                       pos="relative"
                       right="0"
                       minW="125px"
                     >
                       <MenuItem
                          onClick={() =>
                            openHospitalModal(item.id, "edit")
                          }
                        //  isDisabled={
                        //    actionAccess && !actionAccess.update
                        //      ? true
                        //      : false
                        //  }
                       >
                         Edit
                       </MenuItem>

                       <MenuItem
                         onClick={() => {
                          openDeleteModal(
                            item.id,
                            item.hospitalname
                          );
                        }}
                        //  isDisabled={
                        //    actionAccess && !actionAccess.update
                        //      ? true
                        //      : false
                        //  }
                       >
                         Delete
                       </MenuItem>
                     </MenuList>
                   </Menu>    
                 </Box>
                 
             </Box>
             <Flex w='100%' mb="0.75rem" justifyContent='space-between'>
               <Box display='flex' flexDir='column'>
               
                   <Text fontSize="10px" color="gray.500">
                     Product type
                   </Text>
                   <Text fontSize="12px" fontWeight="600">
                     {item.email ? item.email : "-"}
                   </Text>
                   
                 </Box>
                 <Box display='flex' flexDir='column' alignItems="center">
               
               <Text fontSize="10px" color="gray.500">
                 Batch no.
               </Text>
               <Box
                   as="button"
                 >
                   <Text fontSize="12px" fontWeight="600">
                   {item.mobile ? item.mobile : "-"}
               </Text>
                 </Box>
               
             
             </Box>
             </Flex>
           
           </CardBody>

         </Card>
       ))) : (
         <Text>No data available</Text>
       )}
       </Flex>
     </>
    )}
      <ModalRight
        ref={addHospital}
        header="Add New Center"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            <Box w="100%" py="1rem">
              <Box w="100%" display="flex" flexDir="column">
                <PrimaryInput
                  inputPlace="Enter Name*"
                  //   variant="leftSide"
                  //   inputValue={"firstname"}
                  onChange={(e) => setHospitalName(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="Enter Email"
                  variant="bothSide"
                  //   inputValue={email}
                  onChange={(e) => setHospitalEmail(e.target.value)}
                />
                <PrimaryInputDropdown
                  onChange={(e) =>
                    setHospitalMobile(
                      e.target.value.replace(/[^0-9]/g, "").slice(0, 11)
                    )
                  }
                  inputValue={hospitalMobile}
                  id="mobile"
                  variant="bothSide"
                  placeholderProp="Phone number"
                />
                <Textarea
                  placeholder="Enter Address"
                  borderRadius="0 0 10px 10px"
                  value={hospitalBranch}
                  onChange={(e) => setHospitalBranch(e.target.value)}
                />
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => addHospital.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={saveHospitalData} />
            </Flex>
          </>
        }
      />

      <ModalRight
        ref={editHospital}
        header="Edit Center"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            {hospitalData && hospitalData.length > 0 && (
              <Box w="100%" py="1rem">
                <Box w="100%" display="flex" flexDir="column">
                  <PrimaryInput
                    inputPlace="Enter Name*"
                    //   variant="leftSide"
                    defaultValue={hospitalName}
                    onChange={(e) => setHospitalName(e.target.value)}
                  />
                  <PrimaryInput
                    inputPlace="Enter Email"
                    variant="bothSide"
                    defaultValue={hospitalEmail}
                    onChange={(e) => setHospitalEmail(e.target.value)}
                  />
                  <PrimaryInputDropdown
                    onChange={(e) =>
                      setHospitalMobile(
                        e.target.value.replace(/[^0-9]/g, "").slice(0, 11)
                      )
                    }
                    defaultValue={hospitalMobile}
                    id="mobile"
                    variant="bothSide"
                    placeholderProp="Phone number"
                  />
                  <Textarea
                    placeholder="Enter Address"
                    borderRadius="0 0 10px 10px"
                    defaultValue={hospitalBranch}
                    onChange={(e) => setHospitalBranch(e.target.value)}
                  />
                </Box>
              </Box>
            )}
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => editHospital.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={updateHospitalData} />
            </Flex>
          </>
        }
      />

      {/* Delete general dietician notes */}
      <DynamicModal
        ref={deleteHospitalDataModal}
        modalHeader={`Delete Center`}
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to Delete {hospitalName}?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                deleteHospitalData();
                deleteHospitalDataModal.current.closeModal();
              }}
            />
          </>
        }
      />

      
    </>
  );
};

export default ReferHospitals;
